import ActivityRule from './activity-rule'
export default ActivityRule